import { DiscountDto } from "../../../types";

export const GET_ONE_DISCOUNT = "GET_ONE_DISCOUNT";
export const GET_ONE_DISCOUNT_SUCCESS = "GET_ONE_DISCOUNT_SUCCESS";
export const GET_ONE_DISCOUNT_ERROR = "GET_ONE_DISCOUNT_ERROR";
export const UPDATE_CURRENT_DISCOUNT = "UPDATE_CURRENT_DISCOUNT";
export const RESET_CURRENT_DISCOUNT = "RESET_CURRENT_DISCOUNT";

export interface GetOneDiscount {
  type: typeof GET_ONE_DISCOUNT;
  payload: { id: number };
}

export interface GetOneDiscountSuccess {
  type: typeof GET_ONE_DISCOUNT_SUCCESS;
  payload: DiscountDto;
}

export interface GetOneDiscountError {
  type: typeof GET_ONE_DISCOUNT_ERROR;
  payload: string | boolean;
}

export interface UpdateCurrentDiscount {
  type: typeof UPDATE_CURRENT_DISCOUNT;
  payload: DiscountDto;
}

export interface ResetCurrentDiscount {
  type: typeof RESET_CURRENT_DISCOUNT;
  payload: undefined;
}

export interface State {
  data: DiscountDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetOneDiscount
  | GetOneDiscountSuccess
  | GetOneDiscountError
  | UpdateCurrentDiscount
  | ResetCurrentDiscount
